// Error messages by error type
export default validationMessages = {
        missingValue: {
            checkbox: 'Dit veld is verplicht.',
            radio: 'Gelieve een waarde te selecteren.',
            select: 'Gelieve een waarde te selecteren.',
            'select-multiple': 'Gelieve ten minste één waarde te selecteren.',
            default: 'Vul dit veld in a.u.b.'
        },
        patternMismatch: {
            email: 'Gelieve een geldig e-mailadres in te voeren.',
            url: 'Gelieve een URL in te voeren.',
            number: 'Gelieve een getal in te voeren',
            color: 'Gelieve het volgende formaat te gebruiken: #rrggbb',
            date: 'Gelieve het formaat JJJJ-MM-DD te gebruiken',
            time: 'Gelieve het 24-uurs tijdformaat te gebruiken. Bv. 23:00',
            month: 'Gelieve het formaat JJJJ-MM te gebruiken',
            default: 'Gelieve het gevraagde formaat te gebruiken.'
        },
        outOfRange: {
            over: 'Gelieve een waarde te selecteren die niet meer is dan {max}.',
            under: 'Gelieve een waarde te selecteren die niet minder is dan {min}.'
        },
        wrongLength: {
            over: 'Gelieve deze tekst in te korten tot niet meer dan {maxLength} tekens. U gebruikt momenteel {length} tekens.',
            under: 'Gelieve deze tekst te verlengen tot {minLength} tekens of meer. U gebruikt momenteel {length} tekens.'
        }
    };